<div class="content dark">
	<div class="row">
		<div class="col-12">
			<div class="item-panel">
				<div class="heading">Maintenance History</div>
				<div class="content">
					<div *ngIf="logs && !logs.length">
						No maintenance logs have been entered
					</div>
					<div *ngIf="logs && logs.length" class="maintenance-list">
						<table>
							<tr>
								<th>Date</th>
								<th>Entered by</th>
								<th>LRU</th>
								<th>Summary</th>
								<th *ngIf="api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master'">
									Delete</th>
							</tr>
							<tr *ngFor="let log of logs">
								<td>{{log.ts | datetime : "date" }}</td>
								<td>{{log.author_email}}</td>
								<td>{{lookupLRU(log.lru)}}</td>
								<td class="truncate" [title]="log.user_note"><span>{{log.user_note}}</span></td>
								<td *ngIf="api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master'">
									<app-action-button [action]="DeleteMaintenance" [args]="[log.maintenance_history_id]" [context]="this"
										btnClass="btn-danger btn-sm" confirm="Are you sure?" processing="...">x
									</app-action-button>
								</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row" [hidden]="this.api.user.role === 'readonly'">
		<div class="col-12">
			<div class="item-panel">
				<div class="heading">Record new maintenance event</div>
				<div class="content">
					<div class="row">
						<div class="col-lg-4">
							<p>Date of event:</p>
							<app-day-picker [(ngModel)]="newDate"></app-day-picker>
							<p>LRU affected:</p>
							<div class="form-check" *ngFor="let lru of allLRUs">
								<label class="form-check-label">
									<input class="form-check-input" type="radio" name="lruRadios" [value]="lru" [(ngModel)]="newLRU">
									{{lru.name}}
								</label>
							</div>
						</div>
						<div class="col-lg-8">
							<div class="form-group">
								<label>Event summary:</label>
								<div>
									<textarea [(ngModel)]="newSummary" style="width: 100%;height: 150px;"></textarea>
								</div>
							</div>
							<app-action-button [action]="UploadMaintenance" [context]="this" [disabled]="!newDate || !newSummary"
								processing="Saving..." complete="Adjustment recorded">Record maintenance event</app-action-button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>